<mat-nav-list class="less-padding" style="overflow: hidden" class="no-print">
  <a mat-list-item
     routerLink="/home"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">home</mat-icon>
    <span class="nav-menu-text">ホーム</span>
  </a>
  <a mat-list-item
     routerLink="/alerts"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">notifications</mat-icon>
    <span class="nav-menu-text">アラート</span>
  </a>
  <a mat-list-item
     (click)="changeRegisterTree()">
    <mat-icon class="list-item" style="">edit</mat-icon>
    <span class="nav-menu-text">登録</span>
    <span class="fill-remaining-space"></span>
    <mat-icon [ngClass]="{'rotate': isOpenRegisterTree, 'rotate-reverse': !isOpenRegisterTree}">
      expand_more
    </mat-icon>
  </a>
  <a *ngIf="isOpenRegisterTree"
     mat-list-item
     routerLink="/chumon/csv-register"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="chumonAdd" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">注文登録</span>
  </a>
  <a *ngIf="isOpenRegisterTree"
     mat-list-item
     routerLink="/chumon/ichiran"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="chumonList" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">注文一覧</span>
  </a>
  <a *ngIf="isOpenRegisterTree"
     mat-list-item
     routerLink="shiyoulot-register/ikusuu"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="ikusuuLotAdd" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">育雛ロット登録</span>
  </a>
  <a *ngIf="isOpenRegisterTree"
     mat-list-item
     routerLink="shiyoulot-register/ikusei"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="ikuseiLotAdd" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">育成ロット登録</span>
  </a>
  <a mat-list-item
     routerLink="/shiyoulot"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="hen" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">飼養ロット</span>
  </a>
  <a mat-list-item
     routerLink="/keisha-meisai"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">gite</mat-icon>
    <span class="nav-menu-text">鶏舎明細</span>
  </a>
  <a mat-list-item
     routerLink="/keisha-info"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="keishaInfoList" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">鶏舎情報</span>
  </a>
  <a mat-list-item
     routerLink="/layout"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">view_quilt</mat-icon>
    <span class="nav-menu-text">レイアウト</span>
  </a>
  <a mat-list-item
     routerLink="/event/list"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">list_alt</mat-icon>
    <span class="nav-menu-text">作業の登録・確認</span>
  </a>
  <a mat-list-item
     routerLink="/event/calendar"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">event</mat-icon>
    <span class="nav-menu-text">カレンダー</span>
  </a>
  <a mat-list-item
     routerLink="/genzai-wasuu"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon svgIcon="species" class="list-item" style="font-size: 48px;"></mat-icon>
    <span class="nav-menu-text">現在羽数確認</span>
  </a>
  <a mat-list-item
     routerLink="/shiboukei-report"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">difference</mat-icon>
    <span class="nav-menu-text">死亡鶏報告書</span>
  </a>
  <a mat-list-item
     *ngIf="sessionService.session.customerAdmin"
     routerLink="/masters"
     routerLinkActive="active-list-item"
     (click)="clickMenuItem.emit();">
    <mat-icon class="list-item">settings</mat-icon>
    <span class="nav-menu-text">マスター</span>
  </a>
  <a mat-list-item
     routerLinkActive="active-list-item"
     (click)="this.sessionService.logout();">
    <mat-icon class="list-item">logout</mat-icon>
    <span class="nav-menu-text">ログアウト</span>
  </a>
</mat-nav-list>
